
import React from 'react';
import { CountryData } from '@/constants/countryCodes';
import { SvgFlag } from './SvgFlag';
import { getCountryCodeFromName } from '@/utils/countryMapping';

interface CountryFlagProps {
  country: CountryData | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const CountryFlag: React.FC<CountryFlagProps> = ({ 
  country, 
  size = 'md', 
  className = '' 
}) => {
  if (!country) {
    return null;
  }

  // Try to get country code from the country name
  const countryCode = getCountryCodeFromName(country.name);
  
  if (countryCode) {
    return (
      <SvgFlag 
        countryCode={countryCode}
        size={size}
        className={className}
        fallback={country.flag}
      />
    );
  }

  // Fallback to emoji flag if no SVG available
  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  };

  return (
    <div className={`flex items-center justify-center ${sizeClasses[size]} ${className}`} title={country.name}>
      <span className="leading-none">{country.flag}</span>
    </div>
  );
};
